import { COMPONENTS } from '../../components/components.registry';
import { CoreConfig } from '../../models';
import { DeepPartial } from '../../utils';

export const DEFAULT_CORE_CONFIG: DeepPartial<CoreConfig> = {
  template: COMPONENTS.TEMPLATES.MaxWidthTemplate
};
